var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledArrowLeftNoStem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#535759"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5c-.163 0-.325-.055-.457-.166L.257 3.763C-.046 3.51-.087 3.06.166 2.757c.252-.303.702-.344 1.005-.092l3.837 3.198 3.83-3.083c.307-.247.757-.198 1.004.109s.199.756-.108 1.004l-4.286 3.45c-.13.104-.29.157-.448.157",
    transform: "translate(-30 -1195) translate(20 1184) translate(10 11) rotate(90 5 5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledArrowLeftNoStem);
export default __webpack_public_path__ + "static/media/icon-filled-arrow-left-no-stem.78f9d791a6d9f545f1153dd1f4ad243a.svg";
export { ForwardRef as ReactComponent };